











































import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import IconFa6SolidXmark from '~icons/fa6-solid/xmark'
import PriceBrickPCPAndPLP from '~/components/feature/price-brick/PriceBrickPCPAndPLP.vue'

// Store
import { useSearchStore } from '@/store/search'

// Composable
import { useVueModal } from '@/composables/ui/useVueModal'
import { useI18n } from '@/composables/i18n'

// types
import { AddToBasketModalInterface } from '@/types/product/productTypes'

// Store
import { useProductStore } from '@/store/product'
import { useCountry } from '~/composables/country/useCountry'

export default defineComponent({
  components: { IconFa6SolidXmark, PriceBrickPCPAndPLP },
  setup() {
    const searchStore = useSearchStore()
    const productStore = useProductStore()
    const { fetchFullProduct } = productStore
    const modal = useVueModal()
    const { t } = useI18n()
    const page = ref('')
    const productName = ref('')
    const productNumber = ref('')
    const trackingEventName = ref('')
    const currentProduct: any = ref(null)
    const isLoading = ref(false)
    const { isCN } = useCountry()

    const setData = async (options: AddToBasketModalInterface): Promise<void> => {
      // For both PCP & PLP
      trackingEventName.value = options.params.trackingEventName

      // When on the PLP
      if (options.params.searchData) {
        page.value = 'PLP'
        productName.value = options.params.searchData.name?.raw || ''
        productNumber.value = options.params.searchData.productnumber.raw

        try {
          isLoading.value = true
          await fetchFullProduct(productNumber.value)

          currentProduct.value = productStore.products[productNumber.value].data || {
            skuData: [],
          }
        } catch (e) {
          console.error(e)
        } finally {
          isLoading.value = false
          searchStore.setAddToBasketProduct(currentProduct.value)
        }
      }

      // When on PCP
      if (options.params.productData) {
        page.value = 'PCP'
        productNumber.value = options.params.productData.productnumber
        productName.value = options.params.productData.name || ''
        currentProduct.value = options.params.productData
      }
    }

    const isCNDangerousProduct = computed(() => currentProduct.value?.attributes.isCNDangerousGoods && isCN.value)

    const resetData = (): void => {
      searchStore.resetAddToBasketProduct()
    }

    const hideModal = () => {
      modal.hide('add-to-card')
    }

    return {
      setData,
      resetData,
      currentProduct,
      isLoading,
      hideModal,
      t,
      page,
      productName,
      productNumber,
      isCNDangerousProduct,
    }
  },
})
